import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
  <App />
  </React.StrictMode>
);

// Web Vitals - SÓ RODA EM PRODUÇÃO (não afeta hot reload em dev)
// Monitora Core Web Vitals: LCP, FID, CLS (métricas de SEO do Google)
// Para ver métricas, abra o console do browser em produção
if (process.env.NODE_ENV === 'production') {
  import('./reportWebVitals').then(({ sendToAnalytics }) => {
    reportWebVitals(sendToAnalytics);
  });
}
